export default __webpack_public_path__ + "static/women-back-to-work-header-24fec67a12ab83f8e04e9304c8607952.svg";